import { render, staticRenderFns } from "./DispensedToTransport.vue?vue&type=template&id=e77ebb32"
import script from "./DispensedToTransport.vue?vue&type=script&lang=js"
export * from "./DispensedToTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports